/**
 * Plan ve paketler. Kaynak: apps/api/.../billing/seed.py ve
 * docs/pazar/fiyatlandirma.md. Rakamlar GEÇİCİ (YES-104): DernekWeb demosu ve
 * dernek görüşmeleri bitmeden kesinleşmiyor. Değişince yalnızca burası değişir.
 */
export interface Plan {
  kod: string
  ad: string
  /** Aylık, ₺. 0 = görüşmeli. */
  aylik: number
  /** Yıllık toplam, ₺ (12 ay yerine 10 ay bedeli). */
  yillik: number
  uye: number | null
  yonetici: number | null
  epostaAy: number | null
  depolamaGb: number | null
  ozellikler: string[]
  vurgu?: boolean
  kimIcin: string
}

export const YILLIK_AY = 10

export const PLANLAR: Plan[] = [
  {
    kod: 'baslangic',
    ad: 'Başlangıç',
    aylik: 990,
    yillik: 990 * YILLIK_AY,
    uye: 300,
    yonetici: 3,
    epostaAy: 2000,
    depolamaGb: 2,
    kimIcin: 'Tek şubeli, üç yüz üyeye kadar dernekler',
    ozellikler: [
      'Üye yönetimi ve başvuru akışı',
      'Aidat tarifeleri, borçlandırma, hatırlatma',
      'Online tahsilat ve makbuz',
      'Web sitesi (akillidernek.com alt alan adında)',
      'Üye portalı',
      'E-posta gönderimi',
      'Kurullar ve karar defteri',
      'Denetim kaydı ve roller',
    ],
  },
  {
    kod: 'standart',
    ad: 'Standart',
    aylik: 2490,
    yillik: 2490 * YILLIK_AY,
    uye: 1500,
    yonetici: 10,
    epostaAy: 10000,
    depolamaGb: 10,
    vurgu: true,
    kimIcin: 'Büyüyen dernekler ve meslek örgütleri',
    ozellikler: [
      'Başlangıç planındaki her şey',
      'Kendi alan adınız ve otomatik sertifika',
      'Kendi alan adınızdan e-posta',
      'Gelir-gider, bütçe ve raporlar',
      'Bağış sayfası ve kampanya',
      'Banka hareketi eşleştirme',
      'Şube yapısı',
      'Öncelikli destek',
    ],
  },
  {
    kod: 'pro',
    ad: 'Pro',
    aylik: 5990,
    yillik: 5990 * YILLIK_AY,
    uye: 10000,
    yonetici: 30,
    epostaAy: 50000,
    depolamaGb: 50,
    kimIcin: 'Büyük dernekler, federasyonlar, kongre düzenleyenler',
    ozellikler: [
      'Standart planındaki her şey',
      'API erişimi ve webhook',
      'Federasyon görünümü',
      'Online genel kurul ve elektronik oylama',
      'Gelişmiş raporlar ve dışa aktarım',
      'Ayrılmış kaynak: yoğun kongre günlerinde kapasite',
      'Telefonla destek',
    ],
  },
  {
    kod: 'kurumsal',
    ad: 'Kurumsal',
    aylik: 0,
    yillik: 0,
    uye: null,
    yonetici: null,
    epostaAy: null,
    depolamaGb: null,
    kimIcin: 'Konfederasyonlar, birlikler, çok şubeli yapılar',
    ozellikler: [
      'Pro planındaki her şey',
      'Sınırsız üye, yönetici ve e-posta',
      'Tek oturum açma (SSO)',
      'Özel veri taşıma ve entegrasyon',
      'Sözleşmeli hizmet seviyesi',
      'Bağımsız sızma testi raporu',
      'Adanmış müşteri temsilcisi',
    ],
  },
]

export interface Paket {
  kod: string
  ad: string
  aylik: number
  aciklama: string
  modul: string
}

export const PAKETLER: Paket[] = [
  {
    kod: 'etkinlik',
    ad: 'Etkinlik',
    aylik: 1490,
    aciklama: 'Bilet, konaklama, transfer, QR kapı, sponsor, sertifika. Etkinlik başına ücret yok.',
    modul: 'etkinlik-ve-kongre',
  },
  {
    kod: 'akademi',
    ad: 'Akademi',
    aylik: 1490,
    aciklama: 'Kurs, canlı webinar, sınav, sertifika, kupon ve kohort.',
    modul: 'akademi',
  },
  {
    kod: 'ticaret',
    ad: 'Mağaza',
    aylik: 1990,
    aciklama: 'Katalog, varyant, stok ve depo, kargo, kampanya, iade.',
    modul: 'magaza',
  },
]

export const DENEME = {
  gun: 14,
  uye: 50,
  notlar: [
    'Kart bilgisi istenmez.',
    'Online tahsilat test anahtarıyla açık; gerçek para geçmez.',
    'Toplu e-posta ve SMS kapalı; işlem postaları gider.',
    'Deneme bitince veriniz doksan gün saklanır; abone olursanız kaldığınız yerden devam edersiniz.',
  ],
}

export function tl(n: number): string {
  return new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(n) + ' ₺'
}
